import React from "react";
import PropTypes from 'prop-types';
import {Draggable, Droppable} from "react-beautiful-dnd";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import {getRenderItem} from "./getRenderItem";
import {Checkbox} from "@material-ui/core";

import './copyableList.css'
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../Components/JsonScreen/Utils/lib";

const CopyableList = (props) => {
    const {destination, checkBoxChange} = props;
    const {userLanguage} = useSelector(state => state.app);
    return (
        <Droppable
            renderClone={getRenderItem(props.items, props.className)}
            droppableId={props.droppableId}
            isDropDisabled={true}
        >
            {(provided, snapshot) => (
                <List
                    ref={provided.innerRef}
                    className={props.className}
                    dense={true}
                >
                    {props.items.map((item, index) => {
                        const shouldRenderClone = item.name === snapshot.draggingFromThisWith;
                        const isExists = destination.some(e => e.name === item.name);
                        const multiLanguageLabel = multiLanguageValue(item.label, userLanguage);
                        return (
                            <React.Fragment key={item.name}>
                                {shouldRenderClone ? (
                                    <>
                                        <ListItem className="react-beatiful-dnd-copy" disableGutters dense>
                                            <Checkbox
                                                checked={isExists}
                                                size={"small"}
                                                value={isExists || false}
                                                onChange={(event) => checkBoxChange(event, item)}
                                                style={{padding: 0, marginRight: 5}}
                                                color={"primary"}/>
                                            <ListItemText primary={multiLanguageLabel}/>
                                        </ListItem>
                                        <Divider/>
                                    </>
                                ) : (
                                    <Draggable draggableId={item.name} index={index} isDragDisabled={isExists}>
                                        {(provided, snapshot) => (
                                            <React.Fragment>
                                                <ListItem
                                                    disableGutters
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    dense={true}
                                                >
                                                    <Checkbox
                                                        checked={isExists}
                                                        size={"small"}
                                                        value={isExists || false}
                                                        onChange={(event) => checkBoxChange(event, item)}
                                                        style={{padding: 0, marginRight: 5}}
                                                        color={"primary"}
                                                    />
                                                    <ListItemText primary={multiLanguageLabel}/>
                                                </ListItem>
                                                <Divider/>
                                            </React.Fragment>
                                        )}
                                    </Draggable>
                                )}
                            </React.Fragment>
                        );
                    })}
                    {provided.placeholder}
                </List>
            )}
        </Droppable>
    );
};
export default CopyableList

CopyableList.propTypes = {
    items: PropTypes.array,
    droppableId: PropTypes.string,
    destination: PropTypes.array, //destination array
    checkBoxChange: PropTypes.func
};

CopyableList.defaultProps = {
    destination: []
};